import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Connecting to Snowflake',
  content: `
Before we can start modeling your data, Pliable needs to connect to your Snowflake instance. In order to do this, you'll need your Snowflake administrator user to run a setup script in order to give Pliable permission to connect.

# Setup

When you log into Pliable for the first time, after going through onboarding (or skipping the initial set of business questions) you'll be prompted for your Snowflake Host URL (e.g. \`your-account.snowflakecomputing.com\`).

Once you enter your host, you'll get a green checkmark to let you know you have the url in the correct format.

Then, click **Generate Setup Script** to automatically generate the script that will define the role, user name, password, and database name for the Pliable user.

Log into your Snowflake account and run the script in a new worksheet. Make sure **"All Queries"** is checked.

> 📎  you can click edit the default settings to change the settings for the Pliable User login / role / database name in the auto generated script.

Once the script has run in Snowflake, return to Pliable and click **Validate Connection** to make sure you're good to go.

Click **Start modeling your data** to continue.
`,
};

export default doc;
